import {Button} from '@primer/react'
import {Tooltip} from '@primer/react/deprecated'
import {useState} from 'react'

import {BUTTON_LABELS} from '../../constants/buttons'

/**
 * Lightweight shell that mirrors the visual appearance of
 * `@github-ui/issue-create/CreateIssueButton` without pulling in its heavy
 * dependency graph.  Used as the Suspense fallback so users see a real button
 * instead of nothing while the full component lazy-loads.
 *
 * Clicking the shell triggers the lazy chunk and puts the button into a
 * disabled / loading state until React swaps in the real component.
 */
export function CreateIssueButtonShell() {
  const [clicked, setClicked] = useState(false)

  if (clicked) {
    return (
      <Tooltip aria-label="Loading...">
        <Button size={'medium'} disabled>
          {BUTTON_LABELS.new}
        </Button>
      </Tooltip>
    )
  }

  return (
    <Button size={'medium'} variant="primary" onClick={() => setClicked(true)}>
      {BUTTON_LABELS.new}
    </Button>
  )
}
